import { render, staticRenderFns } from "./TripleBoutons.vue?vue&type=template&id=d244f9ba&scoped=true&"
import script from "./TripleBoutons.vue?vue&type=script&lang=js&"
export * from "./TripleBoutons.vue?vue&type=script&lang=js&"
import style0 from "./TripleBoutons.vue?vue&type=style&index=0&id=d244f9ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d244f9ba",
  null
  
)

export default component.exports